<div class="mat-bg-surface flex flex--column">
  <mat-toolbar>
    <h1>
      Agreements
      @if (clientCode()) {
        (<strong>{{ clientName() || clientCode() }} </strong>
        @if (jobNumber()) {
          <em>, {{ jobTitle() || jobNumber() }}</em>
        }
        )
      }
    </h1>
    <span class="spacer"></span>

    <div class="cell-actions">
      @if (canEdit) {
        <button matMiniFab matTooltip="Add Agreement" (click)="edit()">
          <mat-icon>add</mat-icon>
        </button>
      }
      <button matIconButton (click)="reload()" [disabled]="pending()">
        <mat-icon [class.rotating]="pending()">refresh</mat-icon>
      </button>
    </div>
  </mat-toolbar>

  <div class="grid">
    <div class="c-12">
      <div class="cell-actions">
        <mat-form-field>
          <mat-label>Search</mat-label>
          <input matInput [(ngModel)]="filter" />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Status</mat-label>
          <mat-select multiple [(ngModel)]="filterStatus">
            @for (item of statusOptions(); track item) {
            <mat-option [value]="item">{{ item }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <lcm-po-select (poSelected)="filterPo.set($event)" />
      </div>

      <div style="max-width: 100%; overflow-y: auto">
        <table
          mat-table
          matSort
          [dataSource]="source()"
          [trackBy]="trackBy"
          matSortActive="AgreementNumber"
          matSortDirection="desc"
        >
          <ng-container matColumnDef="ClientCode">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>Code</th>
            <td mat-cell *matCellDef="let item">
              <a [routerLink]="['/app/client-accounts/view', item.ClientCode]"> {{ item.ClientCode }} </a>
            </td>
          </ng-container>

          <ng-container matColumnDef="_ClientName">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>Client</th>
            <td mat-cell *matCellDef="let item">{{ item._ClientName }}</td>
          </ng-container>

          <ng-container matColumnDef="JobNumber">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              <mat-icon matTooltip="Product number">shopping_cart</mat-icon>
            </th>
            <td mat-cell *matCellDef="let item">
              <a [routerLink]="['/app/products/view', item.JobNumber]"> {{ item.JobNumber }} </a>
            </td>
          </ng-container>

          <ng-container matColumnDef="AgreementNumber">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              <mat-icon matTooltip="Agreement number">assignment</mat-icon>
            </th>
            <td mat-cell *matCellDef="let item">{{ item.AgreementNumber }}</td>
          </ng-container>

          <ng-container matColumnDef="Title">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let item">{{ item.Title }}</td>
          </ng-container>

          <ng-container matColumnDef="ServiceType">
            <th mat-header-cell *matHeaderCellDef>Type</th>
            <td mat-cell *matCellDef="let item">{{ item.ServiceType }}</td>
          </ng-container>

          <ng-container matColumnDef="StartDate">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>Start</th>
            <td mat-cell *matCellDef="let item">{{ item.StartDate | date: 'dd/MM/y' }}</td>
          </ng-container>

          <ng-container matColumnDef="EndDate">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>Expiry</th>
            <td mat-cell *matCellDef="let item">{{ item.EndDate | date: 'dd/MM/y' }}</td>
          </ng-container>

          <ng-container matColumnDef="BillingCycle">
            <th mat-header-cell *matHeaderCellDef>Billing</th>
            <td mat-cell *matCellDef="let item">{{ item.BillingCycle }}</td>
          </ng-container>

          <ng-container matColumnDef="InvoiceAmount">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>Price</th>
            <td mat-cell *matCellDef="let item">${{ item.InvoiceAmount | number: '.0-2' }}</td>
          </ng-container>

          <ng-container matColumnDef="Status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let item">{{ item.Status }}</td>
          </ng-container>

          <ng-container matColumnDef="JiraTitle">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>Jira</th>
            <td mat-cell *matCellDef="let item">
              <a href="{{ jira.link(item.JiraTitle) }}" target="_blank">{{ item.JiraTitle }}</a>
            </td>
          </ng-container>

          <ng-container matColumnDef="actions" stickyEnd>
            <th mat-header-cell *matHeaderCellDef style="background: transparent"></th>
            <td mat-cell *matCellDef="let item">
              <div class="cell-actions">
                @if (canEdit) {
                  <button matMiniFab (click)="edit(item)" [disabled]="pending()">
                    <mat-icon>edit</mat-icon>
                  </button>
                }
                <button matMiniFab [routerLink]="['view', item.AgreementNumber]">
                  <mat-icon>remove_red_eye</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="columnsToShow()"></tr>
          <tr mat-row *matRowDef="let row; columns: columnsToShow()"></tr>
        </table>
      </div>

      <mat-paginator [pageSize]="10" [showFirstLastButtons]="true" />
    </div>
  </div>
</div>
